<template>
  <div class="ui container">
    <div class="ui active inverted massive text loader"></div>
  </div>
</template>

<script>
export default {
  name: 'loader'
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
